import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaSetNode } from './TypedNode'
import { SchemaSetModel } from './ViewModel'

export const SchemaSetPlugin = createSchemaPlugin(
  'Schema.Set',
  SchemaSetModel,
  SchemaSetNode
)
